export default __webpack_public_path__ + "static/media/bedroom-3.ca9f2f3b.png";